export default "__VITE_ASSET__C$$$87OE__"